<template>
  <div id="ganged-control">
    <div class="control-header flex-align">
      <span class="control-header__title">{{ title }}</span>
      <div v-if="!visibleCreate && (limitShow || limitEditSingle)">
        <el-button
          @click="visibleEdit = !visibleEdit"
          v-show="!visibleEdit"
          type="text"
          icon=" iconfont icon-bianji"
          class="edit-header__btn edit-header__btn--edit flex-align font-labelheavy"
        >
          编辑
        </el-button>
        <el-button
          @click="handleCancelEdit"
          v-if="visibleEdit"
          type="text"
          class="edit-header__btn edit-header__btn--cancel"
        >
          取消
        </el-button>
      </div>
    </div>
    <slot></slot>

    <div class="control-footer">
      <div class="control-footer__cancel">
        <el-button v-if="visibleCancelBtn" @click="handleCancelCloseDialog"
          >取消</el-button
        >
        <el-button v-if="!visibleCancelBtn" @click="handleGoBackLast"
          >返回上一步</el-button
        >
      </div>
      <div class="control-footer__cancel">
        <el-button
          type="primary"
          v-show="visibleNextBtn"
          @click="active = active + 1"
          >下一步</el-button
        >
        <el-button
          type="primary"
          v-show="visibleSaveNextBtn"
          @click="handleSavePart"
          >保存并下一步</el-button
        >
        <el-button type="primary" v-show="visibleQuitBtn" @click="handleQuit"
          >退出</el-button
        >
        <el-button type="primary" v-show="visibleSaveAll" @click="handleSaveAll"
          >保存</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { modelMixin } from '../../assets/js/mixins/model';
export default {
  mixins: [modelMixin],
  props: {
    activeLength: {
      type: Number,
      default: 2
    },
    detailData: {
      type: Object,
      default: () => ({})
    },
    limitEditSingle: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState('relic', ['relicDetail']),
    ...mapState('login', ['limitShow']),
    //控制输入框是否可编辑
    visibleEdit: {
      get() {
        return this.modelValue.visibleEdit;
      },
      set(value) {
        this.modelValue.visibleEdit = value;
      }
    },
    //控制组件变更
    active: {
      get() {
        return this.modelValue.active;
      },
      set(value) {
        this.modelValue.active = value;
      }
    },
    visibleCancelBtn() {
      return this.active === 0;
    },
    visibleCreate() {
      return this.modelValue.visibleCreate;
    },

    title() {
      return this.relicDetail.relicName || this.detailData.relicName;
    },
    visibleSaveAll() {
      return this.active >= this.activeLength && this.visibleEdit;
    },
    visibleSaveNextBtn() {
      return (
        this.active < this.activeLength &&
        this.visibleEdit &&
        !this.visibleCreate
      );
    },
    visibleNextBtn() {
      return (
        (!this.visibleEdit && this.active < this.activeLength) ||
        (this.visibleCreate && this.active < this.activeLength)
      );
    },
    visibleQuitBtn() {
      return this.active >= this.activeLength && !this.visibleEdit;
    }
  },
  methods: {
    /**
     * 退出按钮退出
     */
    handleQuit() {
      this.active = this.activeLength + 1;
      this.modelValue.visibleAddDialog = false;
      this.active = 0;
    },
    handleSaveAll() {
      this.active = this.activeLength + 1;
      this.$emit('onSaveAllClick');
    },

    /**
     * 返回上一个
     */
    handleGoBackLast() {
      this.active = this.active - 1;
      if (!this.modelValue.visibleCreate) {
        this.modelValue.visibleEdit = false;
      }
    },
    /**
     * 取消编辑
     */
    handleCancelEdit() {
      this.visibleEdit = !this.visibleEdit;
      this.$emit('onCancelEdit');
    },
    /**
     * 关闭显示弹窗
     */
    handleCancelCloseDialog() {
      this.modelValue.visibleAddDialog = false;
    },
    /**
     * 保存每一步
     */
    handleSavePart() {
      this.active++;
      this.visibleEdit = !this.visibleEdit;
      this.$emit('onSavePart');
    }
  }
};
</script>

<style lang="scss">
#ganged-control {
  // position: relative;
  .control {
    &-header {
      justify-content: space-between;
      margin: 10px 0px;
      &__title {
        font-size: 16px;
        color: #000;
      }
    }
    &-footer {
      position: absolute;
      bottom: 0px;
      right: 0px;
      display: flex;
      justify-content: flex-end;
      width: 100%;
      background-color: #fff;
      height: 50px;
      // margin-top: 20px;
      .el-button {
        margin: 10px 10px;
        width: auto;
        padding: 0px 10px;
      }
    }
  }
  .edit-header {
    justify-content: space-between;
    border-bottom: 1px solid $color-border-light;
    &__add {
      cursor: pointer;
      padding-bottom: 6px;
      &-img {
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }
      &-text {
        color: $color-primary;
      }
    }
    &__title {
      color: #555;
      font-weight: 900;
    }
    &__btns {
      padding-bottom: 6px;
    }
    &__btn {
      &--edit {
        height: 30px;
        border: 0;
        text-decoration: none;
      }
      &--save {
        height: 24px;
      }
      &--cancel {
        color: $color-info;
      }
      .iconfont {
        font-size: 30px;
        transform: translateY(-2px);
      }
    }
  }
}
@media screen and (max-width: 750px) {
  #ganged-control {
    position: relative;
    .control {
      &-footer {
        position: static;
        display: flex;
        justify-content: flex-end;
        height: 40px;
        background-color: #fff;
        width: 100%;
        margin-top: 20px;
        .el-button {
          margin: 0px 10px;
          width: auto;
          padding: 0px 10px;
        }
      }
    }
  }
}
</style>
